import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const amostrasSlice = createSlice({
  name: 'amostras',
  initialState,
  reducers: {
    carregarAmostra: (state, action) => {
      const { idProcessoItem, amostras } = action.payload;
      state[idProcessoItem] = amostras;
    },
    limparAmostra: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const { carregarAmostra, limparAmostra } = amostrasSlice.actions;
export default amostrasSlice.reducer;
